import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useBFFWebChatDispatch } from '../../hooks';
import { useBFFAnswerFeedbackState } from '../../hooks/state/useBFFAnswerFeedbackState';
import { Modal } from '../Modal';
export const AnswerFeedbackModalPresenter = ({ children }) => {
    var _a, _b, _c, _d, _e, _f;
    const dispatch = useBFFWebChatDispatch();
    const state = useBFFAnswerFeedbackState();
    const channelData = (_c = (_b = (_a = state.context) === null || _a === void 0 ? void 0 : _a.activity) === null || _b === void 0 ? void 0 : _b.channelData) !== null && _c !== void 0 ? _c : {};
    const options = (_e = (_d = channelData.allowedFeedback) === null || _d === void 0 ? void 0 : _d.feedbackOptions) !== null && _e !== void 0 ? _e : [];
    const [returnFocus, setReturnFocus] = useState(false);
    const submitFeedback = useCallback((feedback) => {
        var _a;
        dispatch({ type: 'feedbackClose' });
        setReturnFocus(false);
        (_a = state.context) === null || _a === void 0 ? void 0 : _a.sendAnswerFeedback(feedback);
    }, [dispatch, (_f = state.context) === null || _f === void 0 ? void 0 : _f.sendAnswerFeedback]);
    const close = useCallback(() => {
        setReturnFocus(true);
        dispatch({ type: 'feedbackClose' });
    }, [dispatch]);
    const lastFocusedEl = useRef(null);
    useEffect(() => {
        if (state.isOpen) {
            lastFocusedEl.current = document.activeElement;
        }
    }, [state.isOpen]);
    const onModalClose = useCallback(() => {
        var _a, _b;
        if (returnFocus) {
            (_a = lastFocusedEl.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            (_b = document.querySelector('.webchat__send-box-text-box__input')) === null || _b === void 0 ? void 0 : _b.focus();
        }
        lastFocusedEl.current = null;
    }, [returnFocus]);
    const closeOnEsc = useCallback((event) => {
        if (event.key === 'Escape') {
            close();
        }
    }, [close]);
    useEffect(() => {
        document.addEventListener('keyup', closeOnEsc);
        return () => document.removeEventListener('keyup', closeOnEsc);
    }, [closeOnEsc]);
    return (React.createElement(Modal, { open: state.isOpen, willClose: onModalClose }, React.cloneElement(children, {
        config: {
            options,
            submitFeedback,
            close
        }
    })));
};
//# sourceMappingURL=AnswerFeedbackModalPresenter.js.map